import React, { useState, useEffect, useRef } from "react";

import { milisecondsToTime, getTimeFromDate } from "../utils";
import { Button, Stack, TextField, Typography } from "@mui/material";
import CircularProgress from '@mui/material/CircularProgress';
import { green } from '@mui/material/colors';

import api from "../api";

const CurrentPunchEntrySection = (props) => {

    const [currentPunchEntry, setCurrentPunchEntry] = useState({})
    const [waitingForResponse, setWaitingForResponse] = useState(false)

    const refCurrentPunch = useRef()
    refCurrentPunch.current = currentPunchEntry

    const currentTotal = useRef()
    const [timer, setTimer] = useState("")
    const refTime = useRef()

    const [message, setMessage] = useState("")

    refTime.current = timer

    useEffect(() => {
        currentTotal.current.textContent = "00:00:00"

        setTimer(setInterval(updateTime, 100))
        getCurrentEntry()
        return () => {
            clearInterval(refTime.current)
        }
    }, [props.user.id])

    const getCurrentEntry = async () => {
        let res = await api.get('/current_punch_entries/', { employee: props.user.id })
        setCurrentPunchEntry(res.data)
    }

    const [noteEntry, setNoteEntry] = useState({ note: "" });

    useEffect(() => {
        getNote()
    }, [props.user.id])

    const getNote = async () => {
        const res = await api.get('/submit-new-note/', { employee: props.user.id });
        if (res.status == 200) {
            setNoteEntry(res.data);
        }
    }


    const handleStartStop = async () => {
        setWaitingForResponse(true)
        if (!!!currentPunchEntry.open_time) {
            let res = await api.post('/current_punch_entries/', { employee: props.user.id, open_time: new Date().toISOString() })

            console.log(res.data)
            if (res.status == 201) {
                getNote()
                setCurrentPunchEntry(res.data)
                currentTotal.current.textContent = "00:00:00"
            }
        }
        else {
            let temp_entry = currentPunchEntry
            delete temp_entry.note
            temp_entry['end_time'] = new Date().toISOString()
            let res = await api.put('/current_punch_entries/', temp_entry)

            console.log(res.data)

            if (res.status == 201) {

                props.getEntries(props.user.id)
                getCurrentEntry()
                currentTotal.current.textContent = "00:00:00"
            }
        }
        setWaitingForResponse(false)
    }


    const updateTime = () => {
        if (refCurrentPunch.current.open_time && currentTotal.current) {

            let date = new Date()
            currentTotal.current.textContent = milisecondsToTime((date - new Date(refCurrentPunch.current.open_time)))
        }
    }

    const submitComment = async (e) => {
        e.preventDefault();
        let res = await api.post('/submit-new-note/', { employee: props.user.id, note: noteEntry.note });
        props.getEntries(props.user.id)
        if (res.status === 200) {
            setMessage("Commentaire soumis!")
            const s = setTimeout(() => { setMessage(""); }, 3000)
        }

    }


    return <Stack spacing={1} sx={{ margin: "auto" }}>
        <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }} className="float-start entry-input-total">
            <span ref={currentTotal}>00:00:00</span>
        </div>
        <Typography variant="h6">Entrée courante:</Typography>
        <Stack direction={"row"} style={{ display: "inline-flex", flexWrap: "wrap", justifyContent: "center", maxWidth: "50em" }} spacing={1} flexWrap={"wrap"}>
            <Stack direction={"row"} s>
                <TextField
                    value={getTimeFromDate(currentPunchEntry.open_time) || ""}
                    disabled
                    InputProps={{ className: "punch-textfield", readOnly: true, sx: { width: "14em" } }}
                    InputLabelProps={{ className: "punch-textfield" }}
                    variant="filled"
                    sx={{ width: "14em" }}

                />
                <p style={{ width: "2em" }}>-</p>
                <TextField
                    value={getTimeFromDate(currentPunchEntry.end_time) || ""}
                    className="punch-textfield"
                    InputProps={{ className: "punch-textfield", readOnly: true, sx: { width: "14em" } }}
                    InputLabelProps={{ className: "punch-textfield" }}
                    disabled
                    variant="filled"
                    sx={{ width: "14em" }}
                />
            </Stack>
            <div style={{ position: "relative", display: "flex", alignItems: "stretch" }}>

                <Button
                    variant="contained"
                    className="punch-button"
                    color={currentPunchEntry.open_time ? "error" : "success"}
                    onClick={handleStartStop}
                    sx={{ width: "20em" }}
                    disabled={waitingForResponse}
                >{currentPunchEntry.open_time ? "Arrêter" : "Débuter"}</Button>
                {waitingForResponse && <CircularProgress
                    size={24}
                    sx={{
                        color: green[500],
                        position: 'absolute',
                        top: '50%',
                        left: '50%',
                        marginTop: '-12px',
                        marginLeft: '-12px',
                        zIndex: 1,
                    }}
                />}
            </div>

        </Stack>
        <Stack direction={"row"} style={{ display: "inline-flex", flexWrap: "wrap", justifyContent: "center", maxWidth: "50em" }} spacing={1} flexWrap={"wrap"}>

            {currentPunchEntry.open_time ?
                <TextField
                    style={{ marginTop: "8px" }}
                    label={"Ajouter un commentaire pour l'entrée courante"}
                    className="punch-textfield"
                    value={noteEntry.note || ""}
                    onChange={(e) => setNoteEntry({ ...noteEntry, note: e.target.value })}
                    autoComplete={"false"}
                    required={false}
                    fullWidth
                    sx={{ width: "30em" }}
                />
                :
                <TextField
                    style={{ marginTop: "8px" }}
                    label={"Ajouter un commentaire pour l'entrée précédente"}
                    required={false}
                    className="punch-textfield"
                    value={noteEntry.note || ""}
                    autoComplete={"false"}
                    onChange={(e) => setNoteEntry({ ...noteEntry, note: e.target.value })}
                    fullWidth
                    sx={{ width: "30em" }}
                />

            }
            <Button title="Soummettre le commentaire"
                variant="contained"
                className="punch-button"
                onClick={submitComment}
                sx={{ width: "20em" }}
                disabled={message === "" ? false : true}
                color={message === "" ? "primary" : "success"}
            >{message === "" ? "Soummettre le commentaire" : message}</Button>
        </Stack>

    </Stack>
}
export default CurrentPunchEntrySection